import React__default, { useState, useMemo, useCallback, useEffect } from 'react';
import { EventListener } from '@shopify/polaris';
import { clearUserSelection } from '../../utilities/selection.mjs';
import { DragAndDropContext } from './context.mjs';

let Event = /*#__PURE__*/function (Event) {
  Event["Touch"] = "touchstart";
  Event["Mouse"] = "mousemove";
  return Event;
}({});
function DragAndDropProvider({
  children
}) {
  const [isDragging, setIsDragging] = useState(false);
  const [isTouchDevice, setIsTouchDevice] = useState(false);
  const contextValue = useMemo(() => ({
    isDragging,
    isTouchDevice,
    setIsDragging
  }), [isDragging, isTouchDevice, setIsDragging]);
  const handleTouchEvent = useCallback(() => {
    setIsTouchDevice(true);
  }, []);
  const handleMouseEvent = useCallback(() => {
    setIsTouchDevice(false);
  }, []);

  // While it seems misleading to apply the <EventListener /> when it IS NOT a "touch device"...
  // This is done because there can be "touch-capable" devices that do not register as `isTouchDevice`
  const interactionDetectionListener = isTouchDevice ?
  /*#__PURE__*/
  // We add a mouse detection listener to switch the detection back to mouse handlers if the user starts
  // interacting with their touch-capable device with the mouse again
  React__default.createElement(EventListener, {
    event: Event.Mouse,
    handler: handleMouseEvent,
    passive: true
  }) : /*#__PURE__*/React__default.createElement(EventListener, {
    event: Event.Touch,
    handler: handleTouchEvent,
    passive: true
  });
  useEffect(() => {
    if (isDragging) {
      clearUserSelection();
    }
  }, [isDragging]);
  return /*#__PURE__*/React__default.createElement(DragAndDropContext.Provider, {
    value: contextValue
  }, children, interactionDetectionListener);
}

export { DragAndDropProvider, Event };
